import React from 'react';
import cn from 'classnames';
import { isEmpty } from './format';
import styles from './card.module.css';

/* Таблица вкладки карточки: полная сетка, залипающая шапка, собственная
   прокрутка и счётчик записей под таблицей (п. 10 ТЗ).

   columns: [{ key, title, cell: row => значение, className }]
   Пустое значение ячейки — прочерк приглушённым цветом. */
const CardTable = ({ columns, rows, rowKey, counter, emptyTitle, emptyText }) => {
  if (!rows.length) {
    return (
      <div className={styles.empty}>
        <div className={styles.emptyTitle}>{emptyTitle}</div>
        {emptyText}
      </div>
    );
  }

  return (
    <>
      <div className={styles.gridCard}>
        <div className={styles.gridScroll}>
          <table className={styles.gt}>
            <thead>
              <tr>
                {columns.map(({ key, title }) => <th key={key}>{title}</th>)}
              </tr>
            </thead>
            <tbody>
              {rows.map((row, index) => (
                <tr key={rowKey(row, index)}>
                  {columns.map(({ key, cell, className }) => {
                    const value = cell(row);
                    return (
                      <td key={key} className={cn(className)}>
                        {isEmpty(value) ? <span className={styles.dash}>—</span> : value}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className={styles.counter}>{counter}</div>
    </>
  );
};

export default CardTable;
